export default __webpack_public_path__ + "static/media/rambouillet09.85254678.jpg";